import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user',
  template: `<div class="margin-over-bottom-sidebar"><router-outlet></router-outlet></div>`,
})
export class UserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
